export class CacheItem {
    public key: string;
    public value: any;

    constructor(key, value) {
        this.key = key;
        this.value = value;
    }
}